import { sendGridSyncEndpoint } from 'root/src/server/gateway/actions/mails/endpoints/sendGridSync.endpoint';
export const mailsEndpoints = Object.assign({}, sendGridSyncEndpoint);
